export default __webpack_public_path__ + "img/accha/accha2_700.jpg";